import { Clock4 } from "lucide-react";
import { useState } from "react";

export default function DrawResults({ times = [] }) {
  const [selectedType, setSelectedType] = useState(times.length > 0 ? times[0].time : '');

  // If times is empty, return an empty div to prevent errors
  if (!times || times.length === 0) {
    return <div></div>;
  }

  return (
    <>
      <div className="flex gap-2">
        {times.map(({ time, numbers, gredient }) => (
          <div key={time} className="flex flex-col flex-1 gap-1.5">
            <button
              onClick={() => setSelectedType(time)} // Update selected type
              className={`flex gap-4 max-xs:gap-2 items-center flex-1 rounded-full border font-bold p-1 text-sm ${
                selectedType === time
                  ? "border-yellow-200 text-yellow-200 bg-gradient-to-b from-[#FF0000] via-[#6D1010] to-[#FF0000]"
                  : "border-white text-white text-sm bg-gradient-to-b from-[#0E64D1] via-[#1E429A] to-[#0E64D1]"
              }`}
            >
              <Clock4 className="w-4 h-4 ms-1" />
              {time}
            </button>
            <div className="text-xs text-gray-400 text-center">Results</div>

            <div className="flex justify-center gap-1.5">
              {numbers.map((digit, index) => (
                <div key={index} className="relative flex items-center justify-center w-6 h-6">
                  {/* Rotated segmented border background */}
                  <div
                    className="absolute inset-0 rounded-full"
                    style={{
                      transform: "rotate(25deg)",
                      background: digit.gredient,
                    }}
                  />

                  {/* Inner circle with number (not rotated) */}
                  <div
                    className={`relative flex items-center justify-center w-[22px] h-[22px] rounded-full bg-${digit.color} text-white text-sm font-medium`}
                  >
                    {digit.num}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
